import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {usePermissionsFailureGuard} from '../../hooks/usePermissionsFailureGuard.ts';
import {rbacActions} from "../../config/rbac/actions.ts";

// Single-page module today: account-settings is one summary page. The aliases,
// personas and tags entries nested under it in the navbar are their own modules
// with their own routes, not children of this one. It still uses the module/*
// layout shape so the route carries its own RBAC gate (FNP-1119).
export const AccountSettingsLayout = () => {

    // Interim until FNP-1749: a failed check shows the error page, never a redirect.
    usePermissionsFailureGuard();

    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.GetAccountSettings) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
        </Routes>
    );
};
